import type { WordListPort } from '../../application';

type Loader = () => Promise<readonly string[]>;

/**
 * The validated lists, each fetched only when first asked for — like the catalogues, they stay
 * out of the first download. Arabic is prepared (scripts/wordlists/ar.pool.txt) but not offered
 * until a native speaker has read it; any language not listed here gets no suggestion.
 */
export const VALIDATED_WORD_LISTS: Readonly<Record<string, Loader>> = Object.freeze({
  fr: () => import('./fr.words').then((module) => module.WORDS),
  en: () => import('./en.words').then((module) => module.WORDS),
});

export class LazyWordLists implements WordListPort {
  private readonly loaded = new Map<string, Promise<readonly string[]>>();

  constructor(private readonly loaders: Readonly<Record<string, Loader>> = VALIDATED_WORD_LISTS) {}

  load(language: string): Promise<readonly string[] | null> {
    // "fr-BE" reads as "fr": a list belongs to a language, not to a region.
    const base = language.toLowerCase().replace(/-.*$/su, '');
    const loader = Object.hasOwn(this.loaders, base) ? this.loaders[base] : undefined;
    if (loader === undefined) return Promise.resolve(null);
    let list = this.loaded.get(base);
    if (list === undefined) {
      list = loader();
      this.loaded.set(base, list);
    }
    return list;
  }
}
